module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Regular.8a4fd173.eot";